import React, { FC, useEffect, useMemo, useState } from 'react'

import { useRouter } from 'next/navigation'

import { UserAssignProjectsMain } from 'src/components/organisms'

import { useToast } from 'src/hooks'
import { useGetCompassRoles } from 'src/hooks/useGetCompassRoles'
import { AssignedProjectEntity, UserEntity } from 'src/types'

type Props = {
  user: UserEntity
  projects: AssignedProjectEntity[]
  onClickRow: (project: AssignedProjectEntity) => void
  defaultSelectedProjectId?: string
  className?: string
}

export const UserAssignProjects: FC<Props> = ({
  user,
  projects,
  onClickRow,
  defaultSelectedProjectId,
  className,
}) => {
  const router = useRouter()

  const [selectedProjectId, setSelectedProjectId] = useState<string | null>(null)
  const { displayErrorTextToast } = useToast()
  const { compassRoles, loading: isCompassRolesLoading } = useGetCompassRoles()

  useEffect(() => {
    setSelectedProjectId(defaultSelectedProjectId ?? null)
  }, [defaultSelectedProjectId])

  // NOTE: プロジェクトが未選択の場合はundefined、プロジェクトが見つからない場合はnull、プロジェクトが見つかった場合該当のAssignedProjectEntityを設定
  const selectedProject = useMemo(() => {
    if (!selectedProjectId) {
      return undefined
    }

    return projects.find(project => project.id === selectedProjectId) ?? null

    // 存在しないプロジェクトにアクセスした場合
  }, [projects, selectedProjectId])

  useEffect(() => {
    // 選択されたプロジェクトが見つからない場合はエラー
    if (selectedProject === null) {
      displayErrorTextToast('プロジェクトが見つかりませんでした。')

      // FIXME:
      //  時間がないため苦肉の策
      //  2023/04/13現在 このコンポーネントが呼ばれる箇所が全てgetパラメータでプロジェクトを指定する形式になっているためgetパラメータを省いたページに遷移させる事で対応している
      //  上記の仕様に依存してしまっているため、Propsで適した箇所でエラーハンドリングするようにしたい
      const { origin, pathname } = window.location
      router.replace(`${origin}${pathname}`)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedProject])

  return (
    <div className={className}>
      {!isCompassRolesLoading && (
        <UserAssignProjectsMain
          user={user}
          projects={projects}
          onClickRow={onClickRow}
          compassRoles={compassRoles}
        />
      )}
    </div>
  )
}
